import React from 'react';
import PropTypes from 'prop-types';
import { DialogContent, useMediaQuery } from '@material-ui/core';

// CONSTANTS
import { contentStatuses } from '@/constants/watchList';

// HOOKS
import useDictionary from '@/hooks/useDictionary';

// HELP
import ShowMovieCardWithContent from './ShowMovieCardWithContent';
import ShowMovieDetails from './ShowMovieDetails';
import { ContentDisplayType } from '../constants';

// STYLES
import { DialogStyled, CloseIcon } from '../styles';

const ShowMovieDetailsDialog = ({
  isAuth,
  data,
  onClose,
  open,
  actionLoading,
  addToWatchList,
  removeFromWatchList,
  changeContentStatus,
  analyticsLocation,
  isSharedList,
  swimlaneAnalytics,
  onChangeStatus,
  ...props
}) => {
  const matchesUpSm = useMediaQuery(({ breakpoints }) => breakpoints.up('sm'));
  const genresData = useDictionary(data.genres, 'genres');

  if (!(data && typeof data.id === 'number')) {
    return null;
  }

  function handleChangeStatus(content_status) {
    const { currentlyWatching, wantToWatch } = contentStatuses;
    const { user_content_status } = data;

    const needToClose =
      (user_content_status === currentlyWatching && content_status !== wantToWatch) ||
      (user_content_status === wantToWatch && content_status !== currentlyWatching);

    if (needToClose && !isSharedList) {
      onClose();
    }

    onChangeStatus(data.id, content_status);
  }

  const updatedData = {
    ...data,
    genres: genresData,
  };

  return (
    <DialogStyled
      {...props}
      open={open}
      onClose={onClose}
      fullWidth={matchesUpSm}
      fullScreen={!matchesUpSm}
    >
      <CloseIcon size="medium" aria-label="close" onClick={onClose}>
        <i className="icon-close" />
      </CloseIcon>
      <DialogContent>
        {matchesUpSm ? (
          <ShowMovieDetails
            data={updatedData}
            analyticsLocation={analyticsLocation}
            onChangeStatus={handleChangeStatus}
            swimlaneAnalytics={swimlaneAnalytics}
            isSharedList={isSharedList}
          />
        ) : (
          <ShowMovieCardWithContent
            analyticsLocation={analyticsLocation}
            isAuth={isAuth}
            data={updatedData}
            actionLoading={actionLoading}
            addToWatchList={addToWatchList}
            removeFromWatchList={removeFromWatchList}
            changeContentStatus={changeContentStatus}
            className="movie-card__content"
            displayType={ContentDisplayType.DIALOG}
          />
        )}
      </DialogContent>
    </DialogStyled>
  );
};

ShowMovieDetailsDialog.defaultProps = {
  isAuth: false,
  open: false,
  isSharedList: false,
  onClose: () => {},
  data: {},
  onChangeStatus: () => {},
  removeFromWatchList: () => {},
  swimlaneAnalytics: {},
};

ShowMovieDetailsDialog.propTypes = {
  isSharedList: PropTypes.bool,
  open: PropTypes.bool,
  data: PropTypes.object,
  onClose: PropTypes.func,
  actionLoading: PropTypes.bool,
  isAuth: PropTypes.bool,
  analyticsLocation: PropTypes.string,
  addToWatchList: PropTypes.func.isRequired,
  removeFromWatchList: PropTypes.func,
  changeContentStatus: PropTypes.func.isRequired,
  swimlaneAnalytics: PropTypes.object,
  onChangeStatus: PropTypes.func,
};

export default React.memo(ShowMovieDetailsDialog);
